import gql from 'graphql-tag'

export default type => {
	return {
		mutation: gql`
			mutation insert_conf_contract_types_one(
				$object: conf_contract_types_insert_input!
			) {
				insert_conf_contract_types_one(object: $object) {
					id
				}
			}
		`,
		variables: {
			object: { type }
		}
	}
}
